import { bool, func, number } from 'prop-types';
import React from 'react';
import { Button } from 'reactstrap';

import api from '../../REST/api';
import withApiRequest from '../../REST/with-api-request';

const CheckCreativeAssociationsButton = ({
  campaignId,
  loading,
  onRequest,
}) => (
  <Button
    disabled={loading}
    onClick={() => {
      const linesInRed = document.getElementsByClassName('border-red');
      [...linesInRed].forEach(line => line.classList.remove('border-red'));
      return onRequest({ objectId: campaignId });
    }}
    outline
  >
    Check Creative Assignments
  </Button>
);

CheckCreativeAssociationsButton.propTypes = {
  campaignId: number.isRequired,
  loading: bool.isRequired,
  onRequest: func.isRequired,
};

export default withApiRequest({
  query: api.checkCreativeAssociations,
  error: 'flash',
  successMessage: 'All creatives assignments are valid.',
})(CheckCreativeAssociationsButton);
